var map = {
	"./404.vue": [
		"+H76",
		5
	],
	"./commonRankBoard/index.vue": [
		"7Axa",
		0,
		3
	],
	"./dynamicRankBoard/global.vue": [
		"OdGQ",
		0,
		1
	],
	"./dynamicRankBoard/index.vue": [
		"m8pU",
		0,
		2
	],
	"./globalRaceRankBoard/index.vue": [
		"04U3",
		0,
		6
	],
	"./layout/Layout.vue": [
		"AkUR"
	],
	"./wxRankBoard/index.vue": [
		"ZWPb",
		0,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*\.vue$
// module id = Opzk
// module chunks = 8